if (
  !process.env.REACT_APP_OKTA_ISSUER_DOMAIN ||
  !process.env.REACT_APP_PUSHER_CLIENT_KEY ||
  !process.env.REACT_APP_PUSHER_CLUSTER ||
  !process.env.REACT_APP_PDFTRON_KEY
) {
  throw new Error(
    'Ensure the env variables are setup, as stated in the README.md file',
  );
}

/**
 * This method constructs the api host
 * Checks for current window location path and constructs the api path in a way as:
 *    {protocol}://{subdomain}.api.{domain}
 *    Ex: https://demo.api.nitro.run
 */
const getApiHost = (fallback = process.env.REACT_APP_API_HOST) => {
  const { hostname, protocol } = window.location;

  if (hostname === 'localhost' || process.env.REACT_APP_E2E_ENV) {
    return fallback;
  }
  const domainArr = hostname.split('.');
  const subdomain = domainArr[0];
  const domain = domainArr[1];

  if (subdomain === 'app' && ['nitro', 'rocketlane'].includes(domain)) {
    return hostname.replace(subdomain, `${protocol}//api`);
  }

  return hostname.replace(subdomain, `${protocol}//${subdomain}.api`);
};

// done because for mobile meta alone we need to send 'app', but for other requests we dont
const getApiHostForMobileMeta = (fallback = process.env.REACT_APP_API_HOST) => {
  const { hostname, protocol } = window.location;

  if (hostname === 'localhost' || process.env.REACT_APP_E2E_ENV) {
    return fallback;
  }
  const subdomain = hostname.split('.')[0];

  return hostname.replace(subdomain, `${protocol}//${subdomain}.api`);
};

export const API_HOST = getApiHost();
export const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER;
export const PUSHER_CLIENT_KEY = process.env.REACT_APP_PUSHER_CLIENT_KEY;
export const API_HOST_FOR_MOBILE_META = getApiHostForMobileMeta();
export const API_VERSION = 'v1';
export const API_NAMESPACE = 'api';
export const OKTA_ACCESS_TOKEN_EXPIRY_WINDOW_IN_MINUTES = 15;
export const OKTA_ACCESS_TOKEN_SAFE_WINDOW_IN_MINUTES = 5;
export const OKTA_ACCESS_TOKEN_CHECK_WINDOW_IN_SECONDS = 10;
export const OKTA_ISSUER_DOMAIN = process.env.REACT_APP_OKTA_ISSUER_DOMAIN;

export const PDFTRON_KEY = process.env.REACT_APP_PDFTRON_KEY;

export const CK_HOST =
  window.location.origin.endsWith('.orbits.run') ||
  window.location.origin.endsWith('.nitro.run') ||
  window.location.hostname === 'localhost'
    ? 'docs-stage.nitro.run:443'
    : 'docs.rocketlane.com:443';
const ckeCloudBuild = ['northstar.nitro.run', 'asim.nitro.run'];

const shouldUseCloud = ckeCloudBuild.includes(window.location.hostname);

export const WS_CK_HOST = shouldUseCloud ? '93786.cke-cs.com' : CK_HOST;

export const isCKWsCloud = () => shouldUseCloud;

export const AG_GRID_LICENSE_KEY = process.env.REACT_APP_AG_GRID_LICENSE_KEY;
const BUILD_ID = process.env.REACT_APP_BUILD_ID;

(window as any).BUILD_ID = BUILD_ID;
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log('BUILD_ID', BUILD_ID);
}

export { BUILD_ID };
